<template>
  <div id="upload"></div>
</template>

<script>
  /**
   * Uses Uppy to upload a video directly to S3
   * It creates an Upload on the API and gets a pre-signed S3 URL as a "ticket"
   * The "Upload" is created on the API using the "getUploadParameters" method of Uppy S3 plugin
   */
  import { mapGetters } from 'vuex';
  import Uppy from 'uppy/lib/core';
  import Dashboard from 'uppy/lib/plugins/Dashboard';
  import AwsS3 from 'uppy/lib/plugins/AwsS3';
  import * as APIService from '../services/api';

  export default {
    name: 'Upload',
    // props: [
    //   'creditName',
    //   'creditLinks',
    //   'contact',
    // ],
    watch: {
      // creditName(val) {
      //   // Store the credit data in Uppy's metadata
      //   // Update it when the prop updates
      //   if (!this.uppy) {
      //     return;
      //   }
      //   const meta = this.uppy.opts.meta;
      //   meta.creditName = val;
      //   this.uppy.setMeta(meta);
      // },
      // creditLinks(val) {
      //   // Store the credit data in Uppy's metadata
      //   // Update it when the prop updates
      //   if (!this.uppy) {
      //     return;
      //   }
      //   const meta = this.uppy.opts.meta;
      //   meta.creditLinks = val;
      //   this.uppy.setMeta(meta);
      // },
      // contact(val) {
      //   // Store the contact data in Uppy's metadata
      //   // Update it when the prop updates
      //   if (!this.uppy) {
      //     return;
      //   }

      //   const meta = this.uppy.opts.meta;
      //   meta.contact = val;
      //   this.uppy.setMeta(meta);
      // },
    },
    data() {
      return {
        uppy: null,
      };
    },
    computed: {
      ...mapGetters(['user']),
    },
    // Might need to watch the route?
    mounted() {
      this.initUppy();
    },
    methods: {
      initUppy() {
        this.uppy = Uppy({
          autoProceed: false,
          // Store data in Uppy's metadata
          // Use the data to create an "Upload" on the API
          meta: {
            creditName: this.user.fullname,
            creditLinks: this.user.credit,
          },
          restrictions: {
            maxNumberOfFiles: 4,
          },
          allowedFileTypes: ['video/*'],
        });
        this.uppy.use(Dashboard, {
          target: '#upload',
          inline: true,
          maxHeight: 300,
          width: 940,
          maxWidth: 940,
          locale: {
            strings: {
              dropPaste: 'Drag videos here or',
            },
          },
        });
        this.uppy.use(AwsS3, {
          getUploadParameters(file) {
            // Create an "Upload" on the API
            const promise = APIService.CreateVideo({
              creditName: file.meta.creditName,
              creditLinks: file.meta.creditLinks,
              description: 'video description',
              title: 'video title',
            })
            .then((r) => {
              // Put the API response into the meta for the file
              // eslint-disable-next-line
              file.meta.api = r.data;
              return APIService.GetVideoUploadParams(r.data.id);
            })
            .then(vidUrls => ({
              method: 'PUT',
              url: vidUrls.url,
              fields: { file },
            }));
              // eslint-disable-next-line
            return promise;
          },
        })
        .run();
        this.uppy.on('complete', (result) => {
          // Mark each "Upload" as done when successful
          /* eslint-disable */
          const successful = Promise.all(result.successful.map((f) => {
            return APIService.PatchVideo(f.meta.api.id, {
              status: APIService.STATUS_UPLOADING_DONE,
            });
          }));

          // Mark each failed "Upload" as cancelled
          const failed = Promise.all(result.failed.map((f) => {
            return APIService.PatchVideo(f.meta.api.id, {
              status: APIService.STATUS_CANCELLED,
            });
          }));

          Promise.all([successful, failed]).then((res) => {
            if (result.successful) this.$router.push({ name: 'view-upload-success' });
          });
          /* eslint-enable */
        });
      },
    },
};
</script>

<style lang="scss">
button.uppy-Dashboard-browse {
  vertical-align: baseline;
  &:hover {
    background: #fff;
    text-decoration: underline;
    color: #2275d7;
  }
}
.uppy-Dashboard-inner {
  @media only screen and (max-width: 768px) {
    border-radius: 3px;
  }
}
</style>



// WEBPACK FOOTER //
// Upload.vue?750f4536